import { cn } from "@/utils/cn";
import { NUMBER_TONES } from "./visuals";

/**
 * Step 4, under the questions or the roteiro: "Vamos criar N agentes", in the
 * order a client meets them, with what each one does in a few words.
 */
export default function AgentsToCreate({ agents, note = null }) {
  if (!agents.length) return null;
  return (
    <section
      aria-labelledby="to-create-title"
      className="overflow-hidden rounded-[20px] border border-black/[.08] bg-white/85 backdrop-blur-xl dark:border-white/10 dark:bg-[#0e0e14]/60"
    >
      <h2 id="to-create-title" className="px-5 pb-1.5 pt-[18px] text-[15px] font-semibold text-foreground">
        {agents.length === 1 ? "Vamos criar 1 agente" : `Vamos criar ${agents.length} agentes`}
      </h2>
      <ol aria-label="Agentes que serão criados" className="px-5 pb-2 pt-1.5">
        {agents.map((a, i) => (
          <li key={a.id} className="flex items-center gap-3 border-b border-black/[.05] py-2.5 last:border-0 dark:border-white/[.06]">
            <span
              aria-hidden="true"
              className={cn("flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[13px] font-bold", NUMBER_TONES[i % NUMBER_TONES.length])}
            >
              {i + 1}
            </span>
            <span className="min-w-0 flex-1 text-[15px] text-foreground">{a.name}</span>
            {a.does && <span className="hidden min-w-0 truncate text-right text-[13px] text-muted-foreground sm:block sm:max-w-[55%]">{a.does}</span>}
          </li>
        ))}
      </ol>
      {note && <p className="border-t border-black/[.05] bg-black/[.015] px-5 py-3 text-[13px] text-muted-foreground dark:border-white/[.06] dark:bg-white/[.02]">{note}</p>}
    </section>
  );
}
